<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 资讯动态轮播图 -->
    <DynamicBanner></DynamicBanner>
    <!-- 行业新闻详情 -->
    <NewsDetails :newsId="newsId"></NewsDetails>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import DynamicBanner from "../../../../components/pc/Dynamic/DynamicBanner.vue";
import NewsDetails from "../../../../components/pc/Dynamic/NewsDetails.vue";

export default {
  setup() {
    return reactive({
      newsId: 0,
    });
  },
  created() {
    this.newsId = this.$route.query.id;
  },
  components: {
    TopNav,
    ButtonNav,
    DynamicBanner,
    NewsDetails,
  },
};
</script>

<style scoped>
</style>
